module.exports = __webpack_public_path__ + "img/45.b7ec209e.jpg";